import { render, staticRenderFns } from "./AwardGroupEditor.vue?vue&type=template&id=910b1718&scoped=true&"
import script from "./AwardGroupEditor.vue?vue&type=script&setup=true&lang=js&"
export * from "./AwardGroupEditor.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AwardGroupEditor.vue?vue&type=style&index=0&id=910b1718&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910b1718",
  null
  
)

export default component.exports